/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { sideMenu } from "../Constants/menus";
import { openPanel } from "../Redux/Panels/RightPanel/actions";

export const getMenus = (key="ADMINISTRATOR") => {
	const menus = sideMenu.top;
	return menus || [];
};

const LayoutSideMenu = (props) => {

	if(getMenus(props?.user?.role)?.menus && getMenus(props?.user?.role)?.menus?.length > 0){
		return (
			<div id="layouts-sidebar" className="sidebar-panel is-generic">
				<div className="subpanel-header">
					<div className="dropdown project-dropdown dropdown-trigger is-spaced">
						<div className="h-avatar is-small">
							<span className="avatar is-fake is-h-green">
								<span>{getMenus(props?.user?.role).name[0]}</span>
							</span>
						</div>
						<span className="status-indicator" />
						<div className="dropdown-menu" role="menu">
							<div className="dropdown-content">
								<div className="dropdown-block">
									<div className="h-avatar is-small">
										<span className="avatar is-fake is-warning">
											<span>D</span>
										</span>
									</div>
									<div className="meta">
										<span className="dark-inverted">24Telemed</span>
										<span>Telemedicine Platform</span>
									</div>
								</div>
								<div className="dropdown-block">
									<div className="h-avatar is-small">
										<span className="avatar is-fake is-h-green">
											<span>H</span>
										</span>
									</div>
									<div className="meta">
										<span className="dark-inverted">
											Health and Fitness Dashboard
										</span>
										<span>Fit'n'Dance</span>
									</div>
								</div>
								<div className="dropdown-block">
									<div className="h-avatar is-small">
										<span className="avatar is-fake is-info">
											<span>L</span>
										</span>
									</div>
									<div className="meta">
										<span className="dark-inverted">
											Learning Tracker Dashboard
										</span>
										<span>Fit'n'Dance</span>
									</div>
								</div>
								<div className="dropdown-block">
									<div className="h-avatar is-small">
										<span className="avatar is-fake is-h-purple">
											<span>B</span>
										</span>
									</div>
									<div className="meta">
										<span className="dark-inverted">
											Banking and Finance Dashboard
										</span>
										<span>H Bank</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<h3 className="no-mb">{getMenus(props?.user?.role).name}</h3>
					<div className="panel-close">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width={24}
							height={24}
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth={2}
							strokeLinecap="round"
							strokeLinejoin="round"
							className="feather feather-x"
						>
							<line x1={18} y1={6} x2={6} y2={18} />
							<line x1={6} y1={6} x2={18} y2={18} />
						</svg>
					</div>
				</div>
				<div className="inner" data-simplebar="init">
					<div className="simplebar-wrapper" style={{ margin: 0 }}>
						<div className="simplebar-height-auto-observer-wrapper">
							<div className="simplebar-height-auto-observer" />
						</div>
						<div className="simplebar-mask">
							<div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
								<div
									className="simplebar-content-wrapper"
									style={{ height: "100%", overflow: "hidden scroll" }}
								>
									<div className="simplebar-content" style={{ padding: 0 }}>
										<ul>
											{/* Side Menu Starts */}
											{getMenus(props?.user?.role).menus.map((menu, i) => {
												if (menu.divider) return <li className="divider" />;
												if (menu?.sub?.length > 0) {
													return (
														<li key={i} className={"has-children"}>
															<div className="collapse-wrap">
																<a
																	href="javascript:void(0);"
																	className="parent-link"
																>
																	{menu?.name}
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		width={24}
																		height={24}
																		viewBox="0 0 24 24"
																		fill="none"
																		stroke="currentColor"
																		strokeWidth={2}
																		strokeLinecap="round"
																		strokeLinejoin="round"
																		className="feather feather-chevron-right"
																	>
																		<polyline points="9 18 15 12 9 6" />
																	</svg>
																</a>
															</div>
															<ul>
																{menu?.sub?.map((sub, k) => {
																	return (
																		<li>
																			<a className="is-submenu" href={sub?.link}
																				onClick={e => {
																					if(sub?.action){
																						e.preventDefault();
																						sub.action(props)
																					}
																				}}
																			>
																				<i
																					className={
																						sub?.icon || "lnil lnil-chevron-right"
																					}
																				/>
																				<span>{sub?.name}</span>
																			</a>
																		</li>
																	);
																})}
															</ul>
														</li>
													);
												}
												return (
													<li class="is-activex">
														<a href={menu?.link}
															onClick={e => {
																if(menu?.action){
																	e.preventDefault();
																	menu.action(props)
																}
															}}
														>{menu?.name}</a>
													</li>
												);
											})}
	
											{/* <li className="divider" /> */}
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div
							className="simplebar-placeholder"
							style={{ width: "auto", height: 771 }}
						/>
					</div>
					<div
						className="simplebar-track simplebar-horizontal"
						style={{ visibility: "hidden" }}
					>
						<div
							className="simplebar-scrollbar"
							style={{ width: 0, display: "none" }}
						/>
					</div>
					<div
						className="simplebar-track simplebar-vertical"
						style={{ visibility: "visible" }}
					>
						<div
							className="simplebar-scrollbar"
							style={{
								height: 739,
								display: "block",
								transform: "translate3d(0px, 0px, 0px)",
							}}
						/>
					</div>
				</div>
			</div>
		);
	}else{
		return <div/>
	}
	
};



const mapStateToProps = (state) => {
	return { user: state.user };
};

const mapDispatchToProps = (dispatch) => {
	return { openPanel: (e) => dispatch(openPanel(e)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutSideMenu);


